export const listCodePipelines = `
   query listCodePipelines($nextToken: String) {
       listCodePipelines(nextToken: $nextToken) {
           items {
              name
              arn
              version
              stages {
                name
                actions {
                  name
                  category
                  provider
                  status
                }
              }
              cloudFormationStackName
              lastExecutionStatus
              lastExecutionTime
              created
              updated
           }
           nextToken
       }
   }
`;

export const getCodePipeline = `
   query getCodePipeline($name: String!) {
       getCodePipeline(name: $name) {
         name
         arn
         version
         stages {
           name
           actions {
             name
             category
             provider
             status
           }
         }
         cloudFormationStackName
         lastExecutionStatus
         lastExecutionTime
         created
         updated
       }
}`;
